import { addDays, addMinutes, format, isBefore, isEqual, parse, startOfDay, subMinutes } from 'date-fns';

export function parseTime(day: Date, time: string | undefined | null): Date | undefined {
    return time ? parse(time, 'HH:mm:ss', day) : undefined;
}

export function formatTime(date: Date): string {
    return format(date, 'HH:mm:ss');
}

export function addMinutesToTime(day: Date, time: string, minutes: number): string {
    return formatTime(addMinutes(parse(time, 'HH:mm:ss', day), minutes));
}

export function lastTimeOfDay(reference: Date, stepMinutes: number): Date {
    return subMinutes(startOfDay(addDays(reference, 1)), stepMinutes);
}

export function generateTimeOptions(stepMinutes: number, startTime?: string, endTime?: string): string[] {
    const today = new Date();
    const start = startTime ? parse(startTime, 'HH:mm:ss', today) : startOfDay(today);
    const end = endTime ? parse(endTime, 'HH:mm:ss', today) : lastTimeOfDay(today, stepMinutes);

    let current = start;
    const options: string[] = [];

    while (isBefore(current, end) || isEqual(current, end)) {
        options.push(format(current, 'HH:mm:ss'));
        current = addMinutes(current, stepMinutes);
    }

    return options;
}

export function formatISOTimeForDisplay(timeString: string, formatString = 'H:mm'): string {
    try {
        const date = parse(timeString, 'HH:mm:ss', new Date());
        return format(date, formatString);
    } catch (e) {
        console.error('Error formatting time', e);
        return timeString;
    }
}
